// extracted by mini-css-extract-plugin
module.exports = {"button":"InfoTooltip_button__2odcr"};